// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("white-wall-textures.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Forward Sumner Brand Compliant Styles */

.app-container {
  background: var(--primary-white);
  color: var(--primary-blue);
  font-family: var(--font-body);
  min-height: 100vh;
}

.header, .footer {
  background: var(--primary-blue);
  color: var(--primary-white);
  font-family: var(--font-heading);
  font-weight: 700;
}

.section {
  background: var(--secondary-light-gray);
  border-radius: 1rem;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid var(--secondary-light-gray);
}

.card {
  background: var(--primary-white);
  border: 1px solid var(--secondary-light-gray);
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.08);
  color: var(--primary-blue);
  font-family: var(--font-body);
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 24px rgba(27, 44, 90, 0.12);
  transform: translateY(-2px);
}

.button-primary, .button-secondary {
  margin-top: 1rem;
}

a {
  color: var(--primary-blue);
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 500;
}

a:hover {
  color: var(--primary-gold);
  text-decoration: underline;
}

/* Modal Styles */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
}

.modal-content {
  background: var(--primary-white);
  border-radius: 1rem;
  box-shadow: 0 20px 40px rgba(27, 44, 90, 0.25);
  border: 1px solid var(--secondary-light-gray);
}

/* Search and Filter Styles */
.search-input {
  border: 2px solid var(--secondary-light-gray);
  border-radius: 0.75rem;
  padding: 0.875rem 1rem;
  font-family: var(--font-body);
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);
  outline: none;
}

.filter-select {
  border: 2px solid var(--secondary-light-gray);
  border-radius: 0.75rem;
  padding: 0.875rem 1rem;
  font-family: var(--font-body);
  background: var(--primary-white);
  transition: all 0.3s ease;
}

.filter-select:focus {
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);
  outline: none;
}

/* Loading States */
.loading-spinner {
  border-color: var(--primary-blue);
  border-top-color: var(--primary-gold);
}

/* Error States */
.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  border-radius: 0.75rem;
  padding: 1rem;
}

/* Success States */
.success-message {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #16a34a;
  border-radius: 0.75rem;
  padding: 1rem;
}

/* Pagination */
.pagination-button {
  background: var(--primary-white);
  color: var(--primary-blue);
  border: 2px solid var(--secondary-light-gray);
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-family: var(--font-heading);
  font-weight: 700;
  transition: all 0.3s ease;
}

.pagination-button:hover {
  background: var(--primary-blue);
  color: var(--primary-white);
  border-color: var(--primary-blue);
}

.pagination-button.active {
  background: var(--primary-gold);
  color: var(--primary-blue);
  border-color: var(--primary-gold);
}

/* Responsive Design */
@media (max-width: 768px) {
  .section {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .card {
    margin-bottom: 1rem;
  }
  
  .search-input, .filter-select {
    padding: 0.75rem 0.875rem;
  }
}

/* Wall texture for main background */
.wall-texture-bg {
  background:
    radial-gradient(rgba(0,0,0,0.03) 1px, transparent 1px),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 40px 40px, 200px 200px;
  background-position: 0 0, center;
  background-repeat: repeat, repeat;
}

.bg-wall-texture {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 200px 200px;
  background-repeat: repeat;
  background-position: center;
  background-attachment: fixed; /* Optional: makes it stay in place on scroll */
}

/* JobCard should have a solid background */
.job-card {
  background: #fff !important;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border-width: 2px !important;
}

/* Job card headers should have white background */
.job-card header {
  background: #fff !important;
}

.job-card h3 {
  background: #fff !important;
}

.job-card a {
  background: #fff !important;
}

/* Search filters section should have solid white background */
.bg-blue-50 {
  background-color: #fff !important;
  border-width: 2px !important;
}

/* Sector filter buttons should use the specific blue color */
.bg-sky-600 {
  background-color: #162F5C !important;
}

.border-sky-600 {
  border-color: #162F5C !important;
}

.text-sky-600 {
  color: #162F5C !important;
}

/* Focus area badges should use the specific gold color */
.bg-yellow-500 {
  background-color: #D7B043 !important;
}

/* Financial aid type badges should have stronger colors with reverse type */
.bg-green-100 {
  background-color: #162F5C !important;
}

.text-green-800 {
  color: #fff !important;
}

.border-green-200 {
  border-color: #162F5C !important;
}

/* Apply same styling to all financial aid type badges */
.bg-purple-100, .bg-blue-100, .bg-red-100, .bg-orange-100, .bg-indigo-100, .bg-pink-100 {
  background-color: #162F5C !important;
}

.text-purple-800, .text-blue-800, .text-red-800, .text-orange-800, .text-indigo-800, .text-pink-800 {
  color: #fff !important;
}

.border-purple-200, .border-blue-200, .border-red-200, .border-orange-200, .border-indigo-200, .border-pink-200 {
  border-color: #162F5C !important;
}

/* Make rounded corners match other buttons */
.rounded-full {
  border-radius: 0.375rem !important;
}

/* Ensure search input has white background */
input[type="text"], input[type="search"] {
  background-color: #fff !important;
}

/* Make card borders thicker */
.border {
  border-width: 2px !important;
}

.border-gray-200 {
  border-color: #e5e7eb !important;
}

/* Financial aid cards should have thicker borders */
.bg-white.rounded-xl {
  border-width: 2px !important;
}

/* All card-like elements should have thicker borders */
.card, .modal-content {
  border-width: 2px !important;
}

/* Enhanced loading animations */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    transform: translate3d(0, 0, 0);
  }
  40%, 43% {
    transform: translate3d(0, -8px, 0);
  }
  70% {
    transform: translate3d(0, -4px, 0);
  }
  90% {
    transform: translate3d(0, -2px, 0);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce {
  animation: bounce 1s infinite;
}

/* Loading spinner with brand colors */
.loading-spinner {
  border-color: #162F5C;
  border-top-color: #D7B043;
  animation: spin 1s linear infinite;
}

/* Modal loading state */
.modal-loading {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;EAC7C,mBAAmB;EACnB,6CAA6C;EAC7C,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,6CAA6C;EAC7C,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qCAAqC;AACrC;EACE;;2CAEgC;EAChC,uCAAuC;EACvC,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yDAAgD;EAChD,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B,EAAE,+CAA+C;AAC/E;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8DAA8D;AAC9D;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,6DAA6D;AAC7D;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,oCAAoC;AACtC;;AAEA,4EAA4E;AAC5E;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wDAAwD;AACxD;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,qCAAqC;EACrC,0BAA0B;AAC5B","sourcesContent":["/* Forward Sumner Brand Compliant Styles */\n\n.app-container {\n  background: var(--primary-white);\n  color: var(--primary-blue);\n  font-family: var(--font-body);\n  min-height: 100vh;\n}\n\n.header, .footer {\n  background: var(--primary-blue);\n  color: var(--primary-white);\n  font-family: var(--font-heading);\n  font-weight: 700;\n}\n\n.section {\n  background: var(--secondary-light-gray);\n  border-radius: 1rem;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  border: 1px solid var(--secondary-light-gray);\n}\n\n.card {\n  background: var(--primary-white);\n  border: 1px solid var(--secondary-light-gray);\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.08);\n  color: var(--primary-blue);\n  font-family: var(--font-body);\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  box-shadow: 0 8px 24px rgba(27, 44, 90, 0.12);\n  transform: translateY(-2px);\n}\n\n.button-primary, .button-secondary {\n  margin-top: 1rem;\n}\n\na {\n  color: var(--primary-blue);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\na:hover {\n  color: var(--primary-gold);\n  text-decoration: underline;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: var(--primary-white);\n  border-radius: 1rem;\n  box-shadow: 0 20px 40px rgba(27, 44, 90, 0.25);\n  border: 1px solid var(--secondary-light-gray);\n}\n\n/* Search and Filter Styles */\n.search-input {\n  border: 2px solid var(--secondary-light-gray);\n  border-radius: 0.75rem;\n  padding: 0.875rem 1rem;\n  font-family: var(--font-body);\n  transition: all 0.3s ease;\n}\n\n.search-input:focus {\n  border-color: var(--primary-blue);\n  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);\n  outline: none;\n}\n\n.filter-select {\n  border: 2px solid var(--secondary-light-gray);\n  border-radius: 0.75rem;\n  padding: 0.875rem 1rem;\n  font-family: var(--font-body);\n  background: var(--primary-white);\n  transition: all 0.3s ease;\n}\n\n.filter-select:focus {\n  border-color: var(--primary-blue);\n  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);\n  outline: none;\n}\n\n/* Loading States */\n.loading-spinner {\n  border-color: var(--primary-blue);\n  border-top-color: var(--primary-gold);\n}\n\n/* Error States */\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  border-radius: 0.75rem;\n  padding: 1rem;\n}\n\n/* Success States */\n.success-message {\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  color: #16a34a;\n  border-radius: 0.75rem;\n  padding: 1rem;\n}\n\n/* Pagination */\n.pagination-button {\n  background: var(--primary-white);\n  color: var(--primary-blue);\n  border: 2px solid var(--secondary-light-gray);\n  border-radius: 0.5rem;\n  padding: 0.5rem 1rem;\n  font-family: var(--font-heading);\n  font-weight: 700;\n  transition: all 0.3s ease;\n}\n\n.pagination-button:hover {\n  background: var(--primary-blue);\n  color: var(--primary-white);\n  border-color: var(--primary-blue);\n}\n\n.pagination-button.active {\n  background: var(--primary-gold);\n  color: var(--primary-blue);\n  border-color: var(--primary-gold);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .section {\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .card {\n    margin-bottom: 1rem;\n  }\n  \n  .search-input, .filter-select {\n    padding: 0.75rem 0.875rem;\n  }\n}\n\n/* Wall texture for main background */\n.wall-texture-bg {\n  background:\n    radial-gradient(rgba(0,0,0,0.03) 1px, transparent 1px),\n    url('white-wall-textures.jpg');\n  background-size: 40px 40px, 200px 200px;\n  background-position: 0 0, center;\n  background-repeat: repeat, repeat;\n}\n\n.bg-wall-texture {\n  background-image: url('white-wall-textures.jpg');\n  background-size: 200px 200px;\n  background-repeat: repeat;\n  background-position: center;\n  background-attachment: fixed; /* Optional: makes it stay in place on scroll */\n}\n\n/* JobCard should have a solid background */\n.job-card {\n  background: #fff !important;\n  border-radius: 1rem;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n  border-width: 2px !important;\n}\n\n/* Job card headers should have white background */\n.job-card header {\n  background: #fff !important;\n}\n\n.job-card h3 {\n  background: #fff !important;\n}\n\n.job-card a {\n  background: #fff !important;\n}\n\n/* Search filters section should have solid white background */\n.bg-blue-50 {\n  background-color: #fff !important;\n  border-width: 2px !important;\n}\n\n/* Sector filter buttons should use the specific blue color */\n.bg-sky-600 {\n  background-color: #162F5C !important;\n}\n\n.border-sky-600 {\n  border-color: #162F5C !important;\n}\n\n.text-sky-600 {\n  color: #162F5C !important;\n}\n\n/* Focus area badges should use the specific gold color */\n.bg-yellow-500 {\n  background-color: #D7B043 !important;\n}\n\n/* Financial aid type badges should have stronger colors with reverse type */\n.bg-green-100 {\n  background-color: #162F5C !important;\n}\n\n.text-green-800 {\n  color: #fff !important;\n}\n\n.border-green-200 {\n  border-color: #162F5C !important;\n}\n\n/* Apply same styling to all financial aid type badges */\n.bg-purple-100, .bg-blue-100, .bg-red-100, .bg-orange-100, .bg-indigo-100, .bg-pink-100 {\n  background-color: #162F5C !important;\n}\n\n.text-purple-800, .text-blue-800, .text-red-800, .text-orange-800, .text-indigo-800, .text-pink-800 {\n  color: #fff !important;\n}\n\n.border-purple-200, .border-blue-200, .border-red-200, .border-orange-200, .border-indigo-200, .border-pink-200 {\n  border-color: #162F5C !important;\n}\n\n/* Make rounded corners match other buttons */\n.rounded-full {\n  border-radius: 0.375rem !important;\n}\n\n/* Ensure search input has white background */\ninput[type=\"text\"], input[type=\"search\"] {\n  background-color: #fff !important;\n}\n\n/* Make card borders thicker */\n.border {\n  border-width: 2px !important;\n}\n\n.border-gray-200 {\n  border-color: #e5e7eb !important;\n}\n\n/* Financial aid cards should have thicker borders */\n.bg-white.rounded-xl {\n  border-width: 2px !important;\n}\n\n/* All card-like elements should have thicker borders */\n.card, .modal-content {\n  border-width: 2px !important;\n}\n\n/* Enhanced loading animations */\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes bounce {\n  0%, 20%, 53%, 80%, 100% {\n    transform: translate3d(0, 0, 0);\n  }\n  40%, 43% {\n    transform: translate3d(0, -8px, 0);\n  }\n  70% {\n    transform: translate3d(0, -4px, 0);\n  }\n  90% {\n    transform: translate3d(0, -2px, 0);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.animate-bounce {\n  animation: bounce 1s infinite;\n}\n\n/* Loading spinner with brand colors */\n.loading-spinner {\n  border-color: #162F5C;\n  border-top-color: #D7B043;\n  animation: spin 1s linear infinite;\n}\n\n/* Modal loading state */\n.modal-loading {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
